export default state => state.timezone;
